import * as React from 'react';
var Divider = function Divider(_ref) {
  var className = _ref.className,
    rootPrefixCls = _ref.rootPrefixCls,
    style = _ref.style;
  return React.createElement("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};
Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
export default Divider;